import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "../Components/Loading";
import Table from "../Components/Applications/Table";
import Navbar from "../Components/Navbar";
import Config from "../Config";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../Components/Styles/InputStyles";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../Components/Styles/PageStyles";
import NotFoundModel from "../Components/NotFoundModel";
import DeleteModel from "../Components/Campaigns/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../Config";
import UpdateStatusModel from "../Components/Applications/ConsentModel";
import UploadCertificateModel from "../Components/Applications/UploadCertificateModel";
import CancellationNoticeModel from "../Components/Applications/UploadNoticeModel";
import CancelModel from "../Components/Applications/UploadCancelModel";
import AnnualFeesModal from "../Components/Applications/AnnualFeeModal";
import AdminLCModal from "../Components/Applications/AdminLCModal";
//import SingleEntry from "../../Components/Campaigns/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { toast } from "react-toastify";
import ViewModel from "../Components/Applications/ViewModel";
import { useTranslation } from "react-i18next";

const RegisteredAssociation = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("all");
  const [searchType, setSearchType] = useState("0");
  //const [searchValue, setSearchValue] = useState(email || "");
  const [adminLCModel, setAdminLCModel] = useState(false);
  const [adminLCApiData, setAdminLCApiData] = useState(false);
  const [openViewModel, setOpenViewModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openUpdateStatusModel, setOpenUpdateStatusModel] = useState(false);
  const [openUploadCertificateModel, setOpenUploadCertificateModel] =
    useState(false);
  const [openCancellationNoticeModel, setOpenCancellationNoticeModel] =
    useState(false);
  const [openCancelModel, setOpenCancelModel] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const [editDevice, setEditDevice] = useState(false);

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const navigate = useNavigate();

  const { id } = useParams();
  const { t, i18n } = useTranslation();

  // // ----- Getting Initial Data ------
  const fetchFunction = async (value) => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("status", 0);
    body.append("filter", filter);
    body.append("filterValue", filterValue);
    return await axios.post(`${Config.apiUrl}/registeredassociations`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  // const { isLoading, error, data, refetch, isRefetching } = useQuery(
  //   "getMyRequestsList",
  //   fetchFunction
  // );

  const getAppReSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
  };

  const getAppReError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getAppReSuccess,
    onError: getAppReError,
  });

  useEffect(() => {
    getAppRegMutate(searchType);
  }, []);

  const initialValues = {
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getAppRegMutate(searchType);
    //getReportsMutate(newValues);
  };

  const searchHandler = (value) => {
    setSearchType(value);
    getAppRegMutate(value);
    //getReportsMutate(newValues);
  };

  //------- Update Status -------
  const UpdateStatusFunction = async (values) => {
    // Sukhbir commented on 31st January 2023
    // const body = new FormData();
    // body.append("email", user.email);
    // body.append("userType", user.userType);
    // body.append("id", values.id);
    // body.append("remarks", values.remarks);
    // body.append("status", values.status);
    // body.append("consent", values.consent);
    // return await axios.post(`${Config.apiUrl}/updateassociationstatus`,
    // body,
    // {
    //   headers: {
    //     authorization: user.token,
    //     "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    //   },
    // });
  };

  const onUpdateStatusSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenUpdateStatusModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUpdateStatusError = (res) => {
    setOpenUpdateStatusModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: UpdateStatusLoading, mutate: postUpdateStatus } =
    useMutation(UpdateStatusFunction, {
      onSuccess: onUpdateStatusSuccess,
      onError: onUpdateStatusError,
    });

  //---------Admin LC Detail and generate certificate
  const LCDetailPostFunction = async (values) => {
    const body = new FormData();
    body.append("userType", user.userType);
    body.append("assocId", values.id);
    body.append("serviceType", 5);
    return await axios.post(
      `${Config.apiUrl}/getlostcertificatedetails`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  };

  const onLCSuccess = (res) => {
    //setOpenUploadModel(false);
    //console.log(res);
    if (res?.data?.status == "OK") {
      setAdminLCApiData(res?.data.list);
      setAdminLCModel(true);
    } else {
      toast.error(res?.data?.msg || "An Error Occured");
    }
  };

  const onLCError = (res) => {
    //setOpenUploadModel(false);
    toast.error(res?.data?.msg || "An Error Occured");
  };

  const { isLoading: LCLoading, mutate: setAdminLCMutate } = useMutation(
    LCDetailPostFunction,
    {
      onSuccess: onLCSuccess,
      onError: onLCError,
    }
  );

  //------- Upload Certificate -------
  const UploadCertificateFunction = async (values) => {
    const body = new FormData();
    //body.append("token", user.token);
    body.append("appId", values.appId);
    body.append("cerificate", values.fileName);
    body.append("serviceType", 0);
    return await axios.post(`${Config.apiUrl}/uploadcert`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUploadCertificateSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenUploadCertificateModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUploadCertificateError = (res) => {
    setOpenUploadCertificateModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: uploadCertificateLoading, mutate: postUploadCertificate } =
    useMutation(UploadCertificateFunction, {
      onSuccess: onUploadCertificateSuccess,
      onError: onUploadCertificateError,
    });

  //------- Upload Notice -------
  const UploadNoticeFunction = async (values) => {
    const body = new FormData();
    //body.append("token", user.token);
    body.append("appId", values.appId);
    body.append("notice", values.fileName);
    body.append("serviceType", 0);
    return await axios.post(`${Config.apiUrl}/uploadnotice`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUploadNoticeSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenCancellationNoticeModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUploadNoticeError = (res) => {
    setOpenCancellationNoticeModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: uploadCancellationNoticeLoading,
    mutate: postUploadNotice,
  } = useMutation(UploadNoticeFunction, {
    onSuccess: onUploadNoticeSuccess,
    onError: onUploadNoticeError,
  });

  //------- Upload Cancellation -------
  const UploadCancelFunction = async (values) => {
    const body = new FormData();
    //body.append("token", user.token);
    body.append("appId", values.appId);
    body.append("cancel", values.fileName);
    body.append("serviceType", 0);
    return await axios.post(`${Config.apiUrl}/uploadcancel`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUploadCancelSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenCancelModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUploadCancelError = (res) => {
    setOpenCancelModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: uploadCancelLoading, mutate: postUploadCancel } =
    useMutation(UploadCancelFunction, {
      onSuccess: onUploadCancelSuccess,
      onError: onUploadCancelError,
    });

  /************ Generate Digital Certificate *************/

  const generateCertificateApi = async (values) => {
    const body = new FormData();
    body.append("appId", values.id);
    body.append("serviceType", 5);
    return await axios.post(`${Config.apiUrl}/generatecertificate`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onGenerateCertificateSuccess = (res) => {
    if (res?.data?.status == "OK") {
      setAdminLCModel(false);
      toast.success(res?.data?.msg || "Success");
      getAppRegMutate(searchType);
    } else toast.error(res?.data?.msg || "Error");
  };

  const onGenerateCertificateError = (res) => {
    setAdminLCModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: GenerateCertificateLoading,
    mutate: generateCertificateMutate,
  } = useMutation(generateCertificateApi, {
    onSuccess: onGenerateCertificateSuccess,
    onError: onGenerateCertificateError,
  });

  /******************* End Geneate Digital Certificate ***********************************/

  const submitHandlerTypeSearch = (values) => {
    {
      // setFilterValue(values.filterVal);
      setFilterValue(values.filterVal? values.filterVal : "");
    }
    // console.log(values);
    // console.log(filter);
    // console.log(filterValue);
    getAppRegMutate(values);
    //refetch();
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Registered_Associations")}</Title>
              <Underline />
            </div>
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          <div className="flex items-end justify-between">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
              t={t}
            />
            <TypeFilters
              filter={filter}
              submitHandlerTypeSearch={submitHandlerTypeSearch}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              user={user}
              t={t}
            />
            {/* <InputGroup className="max-w-xs"  style={{flexBasis: 'content'}}>
            <Label htmlFor="startDate">Status</Label>
            <Select
                autoComplete="off"
                className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                value={searchType}
                onChange={(e) => searchHandler(e.target.value)}
              >
                  <MenuItem value="0">All</MenuItem>
                  <MenuItem value="1">Pending Docs</MenuItem>
                  <MenuItem value="2">Pending Payments</MenuItem>
                  <MenuItem value="3">InProgress</MenuItem>
                  <MenuItem value="4">Approved By Asst</MenuItem>
                  <MenuItem value="5">Completed</MenuItem>
                  <MenuItem value="6">Certificate Issued</MenuItem>
                  <MenuItem value="10">Rejected</MenuItem>
              </Select>
              </InputGroup> */}
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>
          {/* {openDeleteModel && (
          <DeleteModel
            deleteDeviceLoading={deleteDeviceLoading}
            setOpenDeleteModel={setOpenDeleteModel}
            groupId={id}
            selectedItem={selectedItem}
            deleteDeviceMutate={deleteDeviceMutate}
          />
        )} */}
          {openUploadCertificateModel && (
            <UploadCertificateModel
              postUploadCertificate={postUploadCertificate}
              uploadCertificateLoading={uploadCertificateLoading}
              setOpenUploadCertificateModel={setOpenUploadCertificateModel}
              selectedItem={selectedItem}
            />
          )}
          {openCancellationNoticeModel && (
            <CancellationNoticeModel
              postUploadNotice={postUploadNotice}
              uploadCancellationNoticeLoading={uploadCancellationNoticeLoading}
              setOpenCancellationNoticeModel={setOpenCancellationNoticeModel}
              selectedItem={selectedItem}
            />
          )}
          {openCancelModel && (
            <CancelModel
              postUploadCancel={postUploadCancel}
              uploadCancelLoading={uploadCancelLoading}
              setOpenCancelModel={setOpenCancelModel}
              selectedItem={selectedItem}
            />
          )}
          {adminLCModel && (
            <AdminLCModal
              setAdminLCModel={setAdminLCModel}
              selectedItem={selectedItem}
              apiData={adminLCApiData}
              generateCertificateMutate={generateCertificateMutate}
            />
          )}

          {openUpdateStatusModel && (
            <UpdateStatusModel
              postUpdateStatus={postUpdateStatus}
              updateStatusLoading={UpdateStatusLoading}
              setOpenUpdateStatusModel={setOpenUpdateStatusModel}
              groupId={id}
              selectedItem={selectedItem}
              userType={user.userType}
            />
          )}
          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedItem}
              gTypeOfGame={gTypeOfGame}
            />
          )}

          {!isLoading && !isRefetching && (
            <TableWrapper>
              <Table
                ApiData={
                  error || data?.data.data == false ? [] : data?.data.data
                }
                // setOpenDeleteModel={setOpenDeleteModel}
                setSelectedItem={setSelectedItem}
                setOpenUpdateStatusModel={setOpenUpdateStatusModel}
                setOpenUploadCertificateModel={setOpenUploadCertificateModel}
                setOpenCancellationNoticeModel={setOpenCancellationNoticeModel}
                setOpenCancelModel={setOpenCancelModel}
                setOpenViewModel={setOpenViewModel}
                setAdminLCMutate={setAdminLCMutate}
              />
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && !isRefetching && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({ initialValues, submitHandler, InitialLoading, user, t }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">{t("Start_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">{t("End_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Date_filter")}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TypeFilters = ({
  filter,
  initialValues,
  submitHandlerTypeSearch,
  InitialLoading,
  setFilter,
  setFilterValue,
  user,
  t,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandlerTypeSearch}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
            <Label htmlFor="filter">{t("Search")}</Label>

            <Select
              autoComplete="off"
              className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
              style={{ height: "40px" }}
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                //searchHandler(e.target.value);
              }}
            >
              <MenuItem value="all">ALL</MenuItem>
              <MenuItem value="assocName">Assoc Name</MenuItem>
              <MenuItem value="assocNo">Assoc No.</MenuItem>
              <MenuItem value="region">Region</MenuItem>
              <MenuItem value="district">District</MenuItem>
            </Select>
          </InputGroup>
          <InputGroup className="max-w-xs">
            <Label htmlFor="filterVal">{t("Value")}</Label>
            <FieldWrapper className="h-10">
              <Field
                type="text"
                name="filterVal"
                id="filterVal"
                class="ml-1"
                //value={filterValue}
                onSubmit={(e) => {
                  setFilterValue(e.target.value);
                  //searchHandler(e.target.value);
                }}
                //  onSubmit={(e) => {
                //   setFilterValue(e.target.value);
                //   //searchHandler(e.target.value);
                // }}
              />
            </FieldWrapper>
          </InputGroup>
          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Search")}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

// const Uploader = ({ setOpenUploadModel }) => {
//   return (
//     <UploadWrapper>
//       <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <MdAdd className="text-white w-5 h-5" /> <p>Run Campaign</p>
//       </Button>
//       {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
//       </Button> */}
//     </UploadWrapper>
//   );
// };

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

export default RegisteredAssociation;
